import(/* webpackMode: "eager", webpackExports: ["ConsentBanner"] */ "/tmp/8deb9be30f8b305/components/consent/ConsentBanner.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Footer"] */ "/tmp/8deb9be30f8b305/components/layout/Footer.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Header"] */ "/tmp/8deb9be30f8b305/components/layout/Header.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["ScrollProgress"] */ "/tmp/8deb9be30f8b305/components/layout/ScrollProgress.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["ScrollToTop"] */ "/tmp/8deb9be30f8b305/components/layout/ScrollToTop.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["PageTracker"] */ "/tmp/8deb9be30f8b305/components/tracking/PageTracker.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["PreloadImages"] */ "/tmp/8deb9be30f8b305/components/ui/PreloadImages.tsx");
;
import(/* webpackMode: "eager" */ "/tmp/8deb9be30f8b305/node_modules/next/dist/client/script.js");
;
import(/* webpackMode: "eager" */ "/tmp/8deb9be30f8b305/node_modules/next/font/google/target.css?{\"path\":\"app/[locale]/layout.tsx\",\"import\":\"Inter\",\"arguments\":[{\"subsets\":[\"latin\"],\"display\":\"swap\",\"preload\":false,\"variable\":\"--font-sans\"}],\"variableName\":\"inter\"}");
;
import(/* webpackMode: "eager" */ "/tmp/8deb9be30f8b305/styles/globals.css");
